import { AofMenuItem } from "./aof-menu/aof-menu.component";

export const mainMenu: AofMenuItem[] = [
    {
        menuTitle: 'menu.header'
    }
];
